import React, { useState } from "react";
import { connect } from "react-redux";
import history from "router/history";
import styled, { css } from "styled-components";
import { rgba } from "polished";
import { MatIcon } from "fiver-react-ui-components";
import TopbarBurger from "./TopbarBurger";
import { createImageCdnLink } from "@low6dev/react-utils/dist";

const StyledWrapper = styled.div`
  position: fixed;
  z-index: 5;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: ${(props) => props.theme.topbarHeight}px;
  color: ${(props) => props.theme.colorPrimaryText};
  background: ${(props) => props.theme.colorTopbar};

  ${(p) =>
    process.env.REACT_APP_COLOR_PRIMARY_IS_WHITE &&
    `border-bottom: 2px solid ${p.theme.colorBorder}`};

  @media (min-width: ${(props) => props.theme.screenWidthMd}) {
    left: 50%;
    width: ${(props) => props.theme.railWidth};
    transform: translateY(
        ${(props) => (props.isVisible ? props.theme.topbarHeight : "0")}px
      )
      translateX(-50%);
  }
`;

const StyledClubLogo = styled.img`
  height: 48px;
  margin: 0 12px;
  object-fit: contain;
`;

const StyledGameLogo = styled.img`
  height: 40px;
  margin-right: 0.75rem;
`;

const StyledPageTitle = styled.div`
  flex: 1;
  font-size: 1.125rem;
  text-align: center;
`;

const Topbar = ({ topbarTitle, buttonWidth, showOptaWidget }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleLogoutSuccess = () => {
    localStorage.removeItem("fiver_react_access_token");
    window.location.reload();
  };

  return (
    <>
      <StyledWrapper>
        <StyledClubLogo
          src={createImageCdnLink(process.env.REACT_APP_CLUB_LOGO)}
        />
        {process.env.REACT_APP_MAIN_LOGO !== "false" && (
          <StyledGameLogo
            src={createImageCdnLink(process.env.REACT_APP_MAIN_LOGO)}
          />
        )}
      </StyledWrapper>
    </>
  );
};

export default Topbar;
